import { PostDiscardSessionModalController } from './modal.controller';
import template from './modal.html';
import { UniqueIdGeneratorUtil } from '@go-modules/utilities/unique-id-generator/unique-id-generator.util';
import './modal.less';

export enum CloseTypeEnum {
	DISMISS,
	DISCARD,
	RESTART,
	SAVE_AND_DRAFT,
	POST
}

export class PostDiscardModal {
	/* @ngInject */
	constructor (private goModalBootstrap) {}

	public open (options) {
		options.template = template;
		options.controller = PostDiscardSessionModalController;
		options.windowClass = options.name = 'post-discard-modal';
		options.keyboard = false;
		options.backdrop = 'static';
		options.controllerAs = '$ctrl';
		options.bindToController = true;
		options.goreact = true; // For new modal styles
		options.modalData = {
			...(options.modalData ?? {}),
			closeTypeEnum: CloseTypeEnum,
			dialogTitleId: options.modalData?.dialogTitleId ?? `post-discard-session-title-${UniqueIdGeneratorUtil.getId()}`
		};

		return this.goModalBootstrap.open(options);
	}
}
